// extracted by mini-css-extract-plugin
export default {"modalBody":"_2ffFt _38618 _1X7sA _3Dqep","modalTextArea":"_10mBH _2kZNz _17S31 _2hwsw _2z9kb"};